import React from "react";
import DivorceRealCostsBox from "./DivorceRealCostsBox";
import DivorceCostCalculator from "./DivorceCostCalculator";
import { STATUS_DATA_COMPLETED } from "@/src/services/divorce/leadStatus";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import ProductBox from "@/src/components/ProductBox/ProductBox";

type DivorceCostBoxProps = {
  divorce?: AbstractCase;
  isInitialCase?: boolean;
};

const DivorceCostBox = ({ divorce, isInitialCase }: DivorceCostBoxProps) => {
  if (isInitialCase || (divorce && divorce.leadStatus < STATUS_DATA_COMPLETED)) {
    return (
      <ProductBox headline={"Kostenrechner"}>
        <DivorceCostCalculator />
      </ProductBox>
    );
  }

  return <ProductBox headline={"Kostenübersicht"}>{divorce && <DivorceRealCostsBox divorce={divorce} />}</ProductBox>;
};

export default DivorceCostBox;
